// @flow
import React from 'react';
import Slider from './Slider';

import '../../../static/scss/components/threeFeature.scss';

const sliderSettings = {
  dots: true,
  arrows: false,
  responsive: [
    { breakpoint: 640, settings: { slidesToShow: 1, infinite: false } },
    { breakpoint: 100000, settings: 'unslick' }
  ]
};

export type Props = {
  modifier?: string,
  children: Array<any>,
  callback?: any => void
};

const ThreeFeatureSlider = ({
  children,
  modifier = 'parking-made-easy',
  callback = () => {}
}: Props) => {
  return (
    <div className={`c-slider c-slider--${modifier}`}>
      <div className="p-grid__module">
        <h2>Parking made easy</h2>
        <div className="c-slider-inner c-slider-inner--three-col">
          <Slider settings={{ ...sliderSettings, infinite: false }}>
            {children.map((child, key) => (
              <div key={key} className="c-slider__item" onClick={callback}>
                {child}
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ThreeFeatureSlider;
